export default "__VITE_ASSET__Cf2tJiOU__"